import { createFileRoute } from '@tanstack/react-router'

import { ServiceAccountDetailPage } from '@/pages/settings/ServiceAccountDetailPage.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/settings/service-accounts/$accountId',
)({
  component: ServiceAccountDetailPage,
})
